import type { ActionAPIError } from './actions'

export const managePageAPIError = (
    state: any,
    action: ActionAPIError,
    path: string,
    stateKey?: string
): any => {
    let key = stateKey ? stateKey : 'error'
    if (action.page === path) {
        return {
            ...state,
            [key]: action.error
        }
    } else {
        return state
    }
}
